module.exports = __webpack_public_path__ + "img/back.2b328f25.svg";